import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography, TextField } from '@quikr/ui';
import Search from '@quikr/ui/src/icons/Search';
import useDebounce from '../../../hooks/useDebounce';

const Hsection = styled.div`
  margin: 43px 0 36px 5px;
`;

const H2 = styled(Typography)`
  margin: 0px;
  color: ${({ theme }) => theme.colors.TextAlpha};
  margin-bottom: 4px;
`;

const PTag = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextBeta};
  margin: 0px;
`;

const HeaderSection = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

const SearchDiv = styled.div`
  width: 300px;
  margin-right: 10px;
`;

const SearchIcon = styled(Search)`
  top: 4px;
`;

const Searchul = styled.ul`
  background: ${({ theme }) => theme.colors.Neutral[600]};
  padding: 0px 10px;
  border: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
`;

const SLi = styled.a`
  padding: 15px 0px;
  color: ${({ theme }) => theme.colors.TextAlpha};
`;

const TopBar = (props) => {
  const { handleSearch } = props;
  const [keyword, setKeyword] = useState('');
  const [searchCat, setSearchCat] = useState([]);
  const [error, setError] = useState('');
  const searchRef = useRef(null);
  const debouncedSearch = useDebounce(keyword, 1000);

  useEffect(() => {
    if (debouncedSearch) {
      if (debouncedSearch && debouncedSearch.length > 1) {
        setSearchCat(handleSearch(debouncedSearch));
      }
    } else {
      setSearchCat([]);
    }
  }, [debouncedSearch]);

  const handleClickOutside = (e) => {
    if (searchRef && !searchRef.current.contains(e.target)) {
      setSearchCat([]);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOnKeyUp = (e) => {
    const { value } = e.target;
    setKeyword(value);
  };

  return (
    <HeaderSection className="dFA jcSB">
      <Hsection className="dF fdC">
        <H2 tagName="h2" modifiers={['h1']}>
          Post Free Ad
        </H2>
        <PTag tageName="p" modifiers={['bt1']}>
          Select a category
        </PTag>
      </Hsection>
      <SearchDiv className="pR" ref={searchRef}>
        <TextField
          className="w100"
          inputName="Search"
          labelName="What will you sell today?"
          leftText={<SearchIcon className="pR" />}
          type="text"
          value={keyword}
          maxLength={30}
          onKeyUp={handleOnKeyUp}
        />
        {error && error != 'success' && (
          <Typography modifiers="bt2" tagName="p">
            {error}
          </Typography>
        )}
        {searchCat && searchCat.length > 0 && (
          <Searchul className="pA w100 zi1 cP dB Slist">
            {searchCat.map((each, index) => (
              <SLi className="dB" href={each.href} key={index}>
                {each.name}
              </SLi>
            ))}
          </Searchul>
        )}
      </SearchDiv>
    </HeaderSection>
  );
};

TopBar.propTypes = {
  handleSearch: PropTypes.func
};

export default TopBar;
